module.exports = __webpack_public_path__ + "static/img/zhutuSAD300.bc3f612.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhutuSAD300.png
// module id = w8O5
// module chunks = 0